import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";

function applyMetaString(address) {
    address.MetaString = `${address.Id} ${address.Name} ${address.Street} ${address.Zip} ${address.City} ${address.Country}`;
    return address;
}

function mapToDto(address) {
    return {
        Id: address.Id,
        CustomerId: address.CustomerId,
        Name: address.Address.Name,
        Street: address.Address.Street,
        Zip: address.Address.Zip,
        City: address.Address.City,
        Country: address.Address.Country
    };
}

export default {
    methods: {

        async getCustomerAdressesByCustomerId(customerId) {
            var meta = { clientApiMethod: 'getCustomerAdressesByCustomerId', input: { customerId: customerId } }
            var response = await client().get(
                `${store.state.apiRouteRoot}CustomerDeliveryAddress/${customerId}/list`,
                { meta: meta }
            );
            response?.data.map((element) => { applyMetaString(element); });
            return response?.data;
        },

        async getCustomerAdressById(ids) {
            var meta = { clientApiMethod: 'getCustomerAdressById', input: { ids } }
            var response = await client().get(
                `${store.state.apiRouteRoot}CustomerDeliveryAddress/${ids.customerId}/${ids.addressId}`,
                { meta: meta }
            );
            return response?.data ? applyMetaString(response.data) : null;
        },

        async createCustomerAdress(address) {
            address = mapToDto(address);
            address.Id = null; //ensure id is null for creation
            var meta = {
                clientApiMethod: 'createCustomerAdress',
                input: { address },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.address.address") })
            }
            var response = await client().put(
                `${store.state.apiRouteRoot}CustomerDeliveryAddress/${address.CustomerId}`, address, { meta: meta }
            );
            return response?.data ? applyMetaString(response.data) : null;
        },

        async changeCustomerAdressById(address) {
            address = mapToDto(address);
            var meta = {
                clientApiMethod: 'changeCustomerAdressById',
                input: { address },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.address.address") })
            }
            var response = await client().put(
                `${store.state.apiRouteRoot}CustomerDeliveryAddress/${address.CustomerId}`, address, { meta: meta }
            );
            return response?.data ? applyMetaString(response.data) : null;
        },

        async swapCustomerAdress(jobId, adressId, silent) {
            var meta = {
                clientApiMethod: 'swapCustomerAdress',
                input: { jobId: jobId, adressId: adressId },
                successText: silent ? undefined : i18n.t("servicesystem.responses.swapped_object", { okey: i18n.t("servicesystem.common_objects.address.address") })
            }
            var response = await client().patch(
                `${store.state.apiRouteRoot}job/${jobId}/swapaddress/${adressId}`, null, { meta: meta }
            );
            return response?.data;
        },
    }
}